import { MagicConfigMixin, configQuery } from '@gig/magic-common';
import { Mixins, Emit, Component } from 'vue-property-decorator';
import { getVariant } from '../../util/variants.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
let ExperimentVwoComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.variant = "";
  }
  created() {
    configQuery("vwoAbTests", (vwoAbTestsConfig) => __async(this, null, function* () {
      if (vwoAbTestsConfig) {
        const variant = yield getVariant(vwoAbTestsConfig);
        this.variant = variant;
        this.emitVariantChange();
      }
    }));
  }
  emitVariantChange() {
    return this.variant;
  }
};
__decorateClass([
  Emit("variant-change")
], ExperimentVwoComponent.prototype, "emitVariantChange", 1);
ExperimentVwoComponent = __decorateClass([
  Component({
    name: "experiment-vwo"
  })
], ExperimentVwoComponent);

export default ExperimentVwoComponent;
